import { useQuery } from '@tanstack/react-query';
import type { Branding } from '@/types/branding';
import { defaultBranding } from '@/types/branding';

declare global {
  interface Window {
    __BRANDING__?: Branding;
  }
}

function getSSRBranding(): Branding | undefined {
  if (typeof window === 'undefined') return undefined
  const b = window.__BRANDING__;
  if (b && typeof b === 'object' && b.workspace_name) return b;
  return undefined;
}

async function fetchBranding(): Promise<Branding> {
  const res = await fetch('/api/v1/public/branding');
  if (!res.ok) return defaultBranding;
  return res.json();
}

export function useBranding() {
  const ssrBranding = getSSRBranding();
  const host = typeof window !== 'undefined' ? window.location.host : ''

  return useQuery({
    queryKey: ['branding', host],
    queryFn: fetchBranding,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    initialData: ssrBranding,
    placeholderData: ssrBranding ? undefined : defaultBranding,
  });
}
